// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback} from 'react';
import cn from 'classnames';
import {useStore} from '@nanostores/react';
import {$is_mobile} from '@pub/store/is_mobile.js';
import {Panel} from '../../comp/panel';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import {Pagination} from '../../comp/pagination';
import {Auth_popup} from '../auth_popup';
import {AUTH_TAB, OFW_TYPE} from '../../utils/constants.js';
import {Details_popup} from './details_popup.js';
import {Item} from './item.js';
import * as cns from './list.module.less';

const get_empty_content = empty_banner=>{
    if (empty_banner)
        return <div>{empty_banner}</div>;
    return <Text.l>No offers found</Text.l>;
};

export function List({
    data={},
    className,
    pagination,
    empty_banner,
    loading,
    pagination_window_size,
})
{
    const {data: list=[], type} = data;
    const [target, set_target] = useState(null);
    const is_mobile = useStore($is_mobile);
    const handle_close = useCallback(()=>set_target(null), []);
    if (!list.length && !loading)
        return get_empty_content(empty_banner);
    const classes = cn(cns.root, {
        [cns.root__has_items]: !!list.length,
    }, className);
    return <div className={classes}>
      <ul className={cn(cns.list, loading&&cns.list__loading)}>
        {list.map(it=><li key={it._id||it.id}>
          <Item data={it} on_click={set_target} has_overlay={!is_mobile}/>
        </li>)}
      </ul>
      {loading&&<Panel className={cns.loader}>
        <Icon ico="spinner" size="xxl"/>
        <Text.m>Looking for best offers</Text.m>
      </Panel>}
      {pagination&&<Pagination className={cns.pagination}
        pagination={pagination} loading={loading}
        window_size={pagination_window_size}/>}
      {type==OFW_TYPE.AUTH
        ? <Details_popup offer={target} on_close={handle_close}/>
        : <Auth_popup show={!!target} on_close={handle_close}
          default_tab={AUTH_TAB.SIGN_UP}/>
      }
    </div>;
}
